// Mount the Raven module: build its host from what only this app can supply and hand it to
// `createRavenModule`. `service-modules.ts` and `service-scopes.ts` take the routes, the CDN-provider
// console and the catalog scope from HERE, so the module cannot be mounted unregistered. The HTTP
// clients are not members: the module reads them from the shared registry
// (`@vnetwork/margarita-core/http`). Every member is already in the entry chunk, so the host is eager.
import { lazy } from 'react';
import { env } from '@/config/env';
import { trackDomainAdd } from '@/lib/analytics-events';
import { createRavenModule, type RavenHost } from '@vnetwork/margarita-raven';
import { withHostBase } from './host-base';

const UsagePage: RavenHost['UsagePage'] = lazy(() => import('@vnetwork/margarita-usage/page'));

const host: RavenHost = withHostBase(['brand', 'trackFeatureAction'], {
  ravenApiUrl: env.ravenApiUrl,
  trackDomainAdd,
  UsagePage,
});

export const raven = createRavenModule(host);
